<div class="ss-wrapper">
  <div fxLayout="column" fxLayoutAlign="center center">
    <div fxLayout="column" fxLayoutAlign="center center">
      <div fxLayout="column" class="container">
        <div fxLayout="row wrap" fxFlex="100" fxLayoutGap="10px" fxLayoutGap.lt-lg="48px" fxLayoutAlign="center center">
          <div class="hero" fxLayoutAlign="center center" fxFlex fxLayout="column">
            @if (configToUse.logo || charity.logo) {
              <img [src]="configToUse.logo || charity.logo" />
            }
            <h1>{{ configToUse.titlePrimary || `Trusted partner ${charity.name}`}}</h1>
            @if (configToUse.textPrimary) {
              <p>
                <span [innerHTML]="shortText"></span>
                <span class="read-more" [style]="{ display: isDescriptionShorthend ? 'inline-block' : 'none' }" (click)="showText()">
                  read more
                </span>
              </p>
            }
            <button
              fxFlex
              fxLayout="row"
              fxLayoutAlign="space-between center"
              fxLayoutGap="10px"
              class="primary"
              (click)="goToPrimaryAction('Hero')"
            >
              <span fxFlex="100">Continue to donation{{ !isSmallWindowSize ? ' pickup' : '' }}</span>
              <mat-icon svgIcon="ss3-arrow-right" />
            </button>
          </div>
        </div>
      </div>
    </div>
    @for (section of configToUse.sections; track section.type) {
      @if (section.isVisible && (sectionTypes.freePickups !== section.type || configToUse.standardEnabled)) {
        <ng-template *ngComponentOutlet="sectionComponents(section.type); inputs: sectionInputs(section.type)" />
      }
    }
  </div>
</div>
